'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductsAndImages = undefined;

var _getProducts = require('./getProducts');

var _getImages = require('./getImages');

var _paths = require('./paths');

/**
 * getProductsAndImages
 * 
 * Fetches both a list of products and their corresponding images.
 * @param {String} feis_id 
 */
var getProductsAndImages = exports.getProductsAndImages = function getProductsAndImages(feis_id, getState) {
  return function (dispatch) {

    var promise = Promise.resolve();
    var products = (0, _paths.productsPath)(getState(), feis_id);

    if (!products || !(products.every(function (pid) {
      return (0, _paths.imagesPath)(getState(), pid);
    }).size > 0)) {
      promise = dispatch((0, _getProducts.getProducts)(feis_id));
    };

    return promise && promise.then(function () {
      return (0, _paths.productsPath)(getState(), feis_id).map(function (pid) {
        return dispatch((0, _getImages.getImages)(feis_id, pid));
      });
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/getProductsAndImages.js
// module id = 662
// module chunks = 0